import { CheckCircle, Clock, Edit, AlertTriangle, Lock } from "lucide-react";

type AssessmentStatusValue =
  | "not_started"
  | "draft"
  | "submitted"
  | "locked"
  | "closed";

interface StatusBadgeProps {
  status: AssessmentStatusValue;
  extra?: string;
}

const statusConfig: Record<
  AssessmentStatusValue,
  { label: string; cls: string; Icon: typeof CheckCircle }
> = {
  not_started: {
    label: "Not Started",
    cls: "text-gray-600 bg-gray-100 dark:bg-gray-700 dark:text-gray-300",
    Icon: Clock,
  },
  draft: {
    label: "Draft",
    cls: "text-yellow-700 bg-yellow-100 dark:bg-yellow-900/30 dark:text-yellow-300",
    Icon: Edit,
  },
  submitted: {
    label: "Submitted",
    cls: "text-green-700 bg-green-100 dark:bg-green-900/30 dark:text-green-300",
    Icon: CheckCircle,
  },
  locked: {
    label: "Locked",
    cls: "text-gray-500 bg-gray-100 dark:bg-gray-700 dark:text-gray-400",
    Icon: Lock,
  },
  closed: {
    label: "Closed",
    cls: "text-gray-500 bg-gray-100 dark:bg-gray-700 dark:text-gray-400",
    Icon: AlertTriangle,
  },
};

export default function StatusBadge({ status, extra }: StatusBadgeProps) {
  const cfg = statusConfig[status];
  const { Icon } = cfg;
  const label = extra ? `${cfg.label} · ${extra}` : cfg.label;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${cfg.cls}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {label}
    </span>
  );
}
